import React, { PropsWithChildren } from "react";

interface ModalHeaderProps {
  className?: string;
  children: React.ReactNode;
}
export const ModalHeader = ({ children, className = "" }: ModalHeaderProps) => {
  return <div className={`text-xl font-semibold text-slate-800 dark:text-slate-100 mb-2 ${className}`}>{children}</div>;
};
